import { Box } from '@mui/material';
import { navbarStyles } from '../Navbar.styles';
import { useState } from 'react';
import { useBreakpoint } from '@/hooks';

export const LogoSection = ({
  hideHackuLogo,
  customLogoUrl,
}: {
  customLogoUrl?: string | null;
  hideHackuLogo: boolean;
}) => {
  const { classes } = navbarStyles();
  const { isDesktop } = useBreakpoint();

  const [logoUrl, setLogoUrl] = useState(customLogoUrl ?? '');

  const onError = () => {
    setLogoUrl(isDesktop ? '/ico-hacku.png' : '/logo-HACKU-color.png');
  };

  // using early return, more code but more readable
  if (!logoUrl && hideHackuLogo) {
    return <></>;
  }

  return (
    <Box display={'flex'} justifyContent={'center'}>
      <Box
        component={'img'}
        src={logoUrl}
        alt="company-logo"
        className={`${classes.iconImage} main-logo-navbar`}
        height={'auto'}
        maxHeight={'40px'}
        maxWidth={{
          xs: '220px',
          sm: '100%',
        }}
        onError={onError}
      />
    </Box>
  );
};
